import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'
import { CommonService } from '../../../../shared/services/common.service'

@Injectable({
  providedIn: 'root',
})
export class QuoteCheckoutService {
  address: any
  soldAddress: any
  checkSubmission = new BehaviorSubject(false)
  copySoldToAddressToshipToAddressCheckBoxValue = new BehaviorSubject(false)

  filesCountData = new BehaviorSubject(0)
  receiveFilesCount = this.filesCountData.asObservable()

  checkboxData = new BehaviorSubject(false)
  receiveCheckboxFlag = this.checkboxData.asObservable()

  constructor(private commonService: CommonService) {}
  sendFilesCount(count) {
    this.filesCountData.next(count)
  }
  sendCheckboxFlag(flag) {
    this.checkboxData.next(flag)
  }
  getUserAddressDetails(userType, cartId) {
    let url
    let urlParam = []
    urlParam = ['users', userType, 'rfqcart', cartId, 'quotecheckout']
    url = this.commonService.constructUrl(urlParam)
    return this.commonService.putData(url)
  }

  getEndUserIndustry(userType) {
    let url
    let urlParam = []
    urlParam = ['users', userType, 'rfqcart', 'endUserIndustry']
    url = this.commonService.constructUrl(urlParam)
    return this.commonService.getData(url)
  }

  getLegalEntity(userType) {
    let url
    let urlParam = []
    urlParam = ['users', userType, 'rfqcart', 'legalEntity']
    url = this.commonService.constructUrl(urlParam)
    return this.commonService.getData(url)
  }

  getOrderType(userType) {
    let url
    let urlParam = []
    urlParam = ['users', userType, 'rfqcart', 'orderType']
    url = this.commonService.constructUrl(urlParam)
    return this.commonService.getData(url)
  }

  postQuoteCheckout(userType, cartId, quoteForm) {
    let url
    let urlParam = []
    urlParam = ['users', userType, 'rfqcart', cartId, 'quoteReview']
    url = this.commonService.constructUrl(urlParam)
    return this.commonService.postData(url, quoteForm)
  }

  uploadFiles(userType, cartId, files: FormData) {
    let api_url
    let urlParam = []
    urlParam = ['users', userType, 'rfqcart', cartId, 'fileUpload']
    api_url = this.commonService.constructUrl(urlParam)
    return this.commonService.postData(api_url, files)
  }

  getQuestions(cartId) {
    const api_url = this.commonService.constructUrl([
      'vsExportCompliance',
      cartId,
      'questions',
    ])
    return this.commonService.getData(api_url)
  }
}
